import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebf5a2ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.message || _ctx.title)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["text-start p-2", { 'error-box': _ctx.error, 'success-box': !_ctx.error }])
      }, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("b", null, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({ 'error-message': _ctx.error, 'success-message': !_ctx.error })
            }, _toDisplayString(_ctx.message), 3))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}